import axios from 'axios'

import store from '../../../store'

import { AUTH__LOGIN_REFRESH, AUTH__LOGOUT } from '../../../store/actions'
import { REFRESH } from '../../auth'

export const BASE_URL = process.env.REACT_APP_BACKEND_URL

const INSTANCE = axios.create({
    headers: {
        'Access-Control-Allow-Origin': '*',
    },
    baseURL: `${BASE_URL}/api`,
    timeout: 30000,
    // withCredentials: true
})
INSTANCE.interceptors.request.use(
    config => {
        const { is_auth, token, language } = store.getState()

        config.headers['Accept-Language'] = `${language.split('-')[0]}`
        if (is_auth && token) {
            config.headers['Authorization'] = `${token.type} ${token.access}`
        }

        return config
    },
    err => {
        return Promise.reject(err)
    },
)
INSTANCE.interceptors.response.use(
    async res => {
        return res.data
    },
    async err => {
        if (err.response) {
            const { user, token } = store.getState()
            const {
                config,
                response: { status, data },
            } = err

            const _url = config.url.replace(config.baseURL, '')

            if (isAccessTokenExpiredOrInvalid(_url, status, data)) {
                return resetTokenAndReattemptRequest(token.refresh, user.optionalId, err)
            }

            if (isRefreshTokenExpired(_url, status, data) || isRefreshTokenInvalid(_url, status, data)) {
                await store.dispatch(AUTH__LOGOUT())
            }
        }

        // if (err.message === 'Network Error') {
        //     await store.dispatch(AUTH__LOGOUT())
        //     window.location.href = '/error'
        // }

        return Promise.reject(err)
    },
)

function isAccessTokenExpiredOrInvalid(url, status, data) {
    return url !== '/oauth/token' && status === 401 && data.error === 'invalid_token'
}
function isRefreshTokenExpired(url, status, data) {
    return url === '/oauth/token' && status === 401 && data.error === 'invalid_token'
}
function isRefreshTokenInvalid(url, status, data) {
    return url === '/oauth/token' && status === 400 && data.error === 'invalid_grant'
}

let isAlreadyFetchingAccessToken = false
let subscribers = []

async function resetTokenAndReattemptRequest(refresh_token, optionalId = null, err) {
    try {
        const { config } = err
        const {
            token: { type: token_type },
        } = store.getState()

        if (!refresh_token) {
            return await Promise.reject(err)
        }

        const retryOriginalRequest = new Promise(resolve => {
            addSubscriber(access_token => {
                config.headers['Authorization'] = `${token_type} ${access_token}`
                resolve(INSTANCE(config))
            })
        })

        if (!isAlreadyFetchingAccessToken) {
            isAlreadyFetchingAccessToken = true

            const response_1 = await REFRESH()
            store.dispatch(AUTH__LOGIN_REFRESH(response_1, optionalId ? optionalId : null))

            const { token } = store.getState()

            isAlreadyFetchingAccessToken = false
            onAccessTokenFetched(token.access)
        }
        return retryOriginalRequest
    } catch (err) {
        return await Promise.reject(err)
    }
}

function onAccessTokenFetched(access_token) {
    subscribers.forEach(callback => callback(access_token))
    subscribers = []
}
function addSubscriber(callback) {
    subscribers.push(callback)
}

export default INSTANCE
